import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import { Input } from '@/shared/components/Input';
import { useClientes } from '@/data/hooks/useClientes';
/**
 * Filtro liviano de cliente para listados. Tipea 2+ caracteres y muestra
 * sugerencias en un dropdown chico. No es un combobox accesible completo,
 * pero alcanza para filtrar listados (no para formularios criticos).
 */
export function ClienteAutocomplete({ clienteNombre, onChange }) {
    const [q, setQ] = useState('');
    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);
    const habilitado = q.trim().length >= 2 && !clienteNombre;
    const { data } = useClientes({ q: q.trim(), pagina: 1, porPagina: 8, activo: true });
    // Cerrar al click fuera.
    useEffect(() => {
        const handler = (e) => {
            if (!wrapRef.current)
                return;
            if (!wrapRef.current.contains(e.target))
                setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);
    if (clienteNombre) {
        return (_jsxs("div", { className: "flex h-9 items-center gap-1.5 rounded-md border border-primary bg-primary-light/40 px-2 text-sm", children: [_jsx("span", { className: "truncate text-text-primary", children: clienteNombre }), _jsx("button", { type: "button", onClick: () => onChange(null), "aria-label": "Quitar filtro de cliente", className: "ml-auto rounded p-0.5 text-text-secondary hover:bg-surface-2 hover:text-text-primary", children: _jsx(X, { className: "h-3.5 w-3.5" }) })] }));
    }
    return (_jsxs("div", { ref: wrapRef, className: "relative", children: [_jsx(Input, { value: q, onChange: (e) => {
                    setQ(e.target.value);
                    setOpen(true);
                }, onFocus: () => setOpen(true), placeholder: "Buscar cliente\u2026", className: "h-9 w-56 text-sm" }), open && habilitado && data && data.items.length > 0 ? (_jsx("ul", { className: "absolute left-0 right-0 top-full z-popover mt-1 max-h-60 overflow-y-auto rounded-md border border-border-subtle bg-surface-3 shadow-modal dark:shadow-modal-dark", children: data.items.map((c) => {
                    const nombre = `${c.nombre} ${c.apellido ?? ''}`.trim();
                    return (_jsx("li", { children: _jsxs("button", { type: "button", onClick: () => {
                                onChange({ id: c.id, nombre });
                                setQ('');
                                setOpen(false);
                            }, className: "block w-full px-3 py-1.5 text-left text-sm text-text-primary hover:bg-surface-2", children: [_jsx("div", { className: "font-medium", children: nombre || '(sin nombre)' }), c.email ? (_jsx("div", { className: "text-[11px] text-text-tertiary", children: c.email })) : null] }) }, c.id));
                }) })) : null, open && habilitado && data && data.items.length === 0 ? (_jsx("div", { className: "absolute left-0 right-0 top-full z-popover mt-1 rounded-md border border-border-subtle bg-surface-3 px-3 py-2 text-sm text-text-tertiary shadow-modal dark:shadow-modal-dark", children: "Sin resultados" })) : null] }));
}
